const getInitialValues = (practice) => ({
  id: null,
  practice_id: practice?.id,
  bill_name: practice?.name,
  bill_npi: '',
  bill_taxid: '',
  bill_taxid_type: '',
  bill_taxonomy: '',
  bill_id: '',
  bill_addr_1: practice?.practiceAddress?.address_ln_1,
  bill_addr_2: practice?.practiceAddress?.address_ln_2,
  bill_city: practice?.practiceAddress?.city,
  bill_state: practice?.practiceAddress?.state,
  bill_zip: practice?.practiceAddress?.zip?.replace(/-/g, ''),
  bill_phone: practice?.phone,
  practitioner_ids: []
});

export default getInitialValues;
